/**
 * Utility functions for handling product images
 */

/**
 * Get the main image URL for a product
 * Handles both legacy array structure and new object structure
 * @param {Object|Array} images - The images data from the product
 * @returns {string|null} The URL of the main image or null if not found
 */
export const getProductImage = (images) => {
  if (!images) return null;

  // Handle new object structure { productImages: [], modelImages: [] }
  if (typeof images === 'object' && !Array.isArray(images)) {
    // Try product images first
    if (images.productImages && Array.isArray(images.productImages) && images.productImages.length > 0) {
      return images.productImages[0];
    }
    // Fallback to model images
    if (images.modelImages && Array.isArray(images.modelImages) && images.modelImages.length > 0) {
      return images.modelImages[0];
    }
    return null;
  }

  // Handle legacy array structure (if any)
  if (Array.isArray(images) && images.length > 0) {
    return images[0];
  }

  return null;
};

/**
 * Get all images as a flat array
 * @param {Object|Array} images - The images data from the product
 * @returns {Array} Array of image URLs
 */
export const getAllImages = (images) => {
  if (!images) return [];

  if (typeof images === 'object' && !Array.isArray(images)) {
    const productImgs = Array.isArray(images.productImages) ? images.productImages : [];
    const modelImgs = Array.isArray(images.modelImages) ? images.modelImages : [];
    return [...productImgs, ...modelImgs];
  }

  if (Array.isArray(images)) {
    return images;
  }

  return [];
};
